import { StylesClasses, createStyles } from '@utils/styles'

const styles = createStyles({
  cardWrapper: {
    display: 'flex',
    gap: '20px',
    flexDirection: {
      xs: 'column',
      md: 'row',
    },
  },
  wrapper: {
    // padding: {
    //   md: '50px 0px',
    // },
    '& .outPortfolioCarousel .swiper-wrapper': {
      display: 'flex',
      gap: { xs: 'unset', md: 'initial' },
    },
  },
})

export type StyleClassNames = StylesClasses<typeof styles>

export default styles
